import * as React from "react";
import { forwardRef } from "react";
const SvgChevronDownSmall = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 8, height: 7, viewBox: "0 0 8 7", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.646 5.354l-3-3 .708-.708L4 4.293l2.646-2.647.708.708-3 3L4 5.707l-.354-.353z", fillRule: "evenodd", fillOpacity: 1, fill: "black", stroke: "none" }));
const ForwardRef = forwardRef(SvgChevronDownSmall);
export default ForwardRef;
